import React, { useContext, useEffect, useState } from "react";
import { ERROR_MESSAGES } from "../../components/common/GlobalMassssage";
import { AuthContext, LoaderContext } from "../../Context/ContextFunctions";
import Select from "react-select";
import { GetServiceLookupList } from "../../services/SettingApi/Service/ServiceApi";
import SuccessModal from "../../components/common/SuccessModal";
import { AddUpdateJob, GetJobCategoryLookupList, GetJobModel, GetJobStatusLookupList } from "../../services/Job/JobApi";
import { GetClientLookupList, GetProjectLookupList } from "../../services/Project/projectApi";
import { globalSelectStyles } from "../../middleware/enum";
import { GeStatusLookupList, GetProjectManagerLookupList, GetTeamLeadLookupList } from "../../services/Staff/StaffApi";
import { UploadImageWithNodeApi } from "../../services/Media/UploadMedia";
import DatePicker from 'react-date-picker';
import { FaEye } from "react-icons/fa";
import { customSelectStyles } from "../../middleware/Utils";

const JobsAddUpdateModal = ({
      isOpen,
      onClose,
      setIsAddUpdateDone,
      modelRequestData,
      clientKeyID,
}) => {

      const { userKeyID } = JSON.parse(localStorage.getItem("login"))

      //===========================state====================
      const [stageObj, setStatusObj] = useState({
            projectStageKeyID: null,
            statusName: "",
      });

      const [requireErrorMessage, setRequireErrorMessage] = useState(false);
      const [showSuccessPopupModal, setShowSuccessPopupModal] = useState(false);
      const [errorMessage, setErrorMessage] = useState(false);
      const [modelAction, setModelAction] = useState("");
      const minDate = new Date(1950, 0, 1);
      const [serviceLookupList, setServiceLookupList] = useState([]);
      const [projectLookupList, setProjectLookupList] = useState([]);
      const [serviceKeyIDs, setServiceKeyIDs] = useState([]);
      const [serviceHours, setServiceHours] = useState({});
      const { authDetails, PanalModuleName } = useContext(AuthContext);
      const { setLoader } = useContext(LoaderContext);
      const [isErrorOpen, setIsErrorOpen] = useState(false);
      const [teamLeadLookupList, setTeamLeadLookupList] = useState([])
      const [projectMangerLookupList, setProjectManagerLookupList] = useState([])
      const [clientLookupList, setClientLookupList] = useState([]);
      const [jobCategoryLookupList, setJobCategoryLookupList] = useState([]);
      const [statusLookupList, setStatusLookupList] = useState([]);
      const [project, setProject] = useState({
            userKeyID: userKeyID,
            jobName: "",
            jobKeyID: null,
            projectID: null,
            clientID: null,
            categoryID: null,
            assignedTL: [],
            asignedTeam: [],
            startDate: null,
            endDate: null,
            jobStatusID: null,
            imageURL: null,
            errors: {}

      });

      useEffect(() => {
            setModelAction(modelRequestData.Action === null ? "Add" : "Update");

            if (
                  modelRequestData.jobKeyID !== undefined &&
                  modelRequestData.jobKeyID !== null &&
                  modelRequestData.Action === "Update"
            ) {
                  GetProjectModalData(modelRequestData.jobKeyID);
            } else {
                  // Reset states for Add mode
                  setProject({

                        userKeyID: userKeyID,
                        jobName: "",
                        jobKeyID: null,
                        projectID: null,
                        clientID: modelRequestData?.clientID || null,
                        categoryID: null,
                        assignedTL: null,
                        asignedTeam: [],
                        startDate: null,
                        endDate: null,
                        jobStatusID: null,
                        imageURL: null,
                  });
                  // setServiceKeyIDs([]);
                  // setServiceHours({});
            }
      }, [modelRequestData]);

      useEffect(() => {
            // GetProjectLookupListData();
            GetTeamLeadLookupListData();
            GetProjectManagerLookupListData();
            GetClientLookupListData();
            GetJobCategoryLookupListData();
            GetStatusLookupListData();
      }, []);

      useEffect(() => {
            if (project.clientID) {
                  GetProjectLookupListData(project?.clientID);
            }
      }, [project.clientID]);


      if (!isOpen) return null;

      // Fetch Project Data for Update
      const GetProjectModalData = async (KeyID) => {
            setLoader(true);
            try {
                  const data = await GetJobModel(KeyID);
                  if (data.statusCode === 200 && data.responseData?.data) {
                        const modalData = data.responseData.data;

                        await GetProjectLookupListData(modalData.clientID)
                        // Populate project state
                        setProject({

                              ...modalData,
                              startDate: modalData.startDate.split("T")[0],
                              endDate: modalData.endDate.split("T")[0]
                        });

                        // Set serviceKeyIDs and serviceHours based on the response
                        const serviceIDs = modalData.serviceKeyIDs.map((s) => s.serviceKeyID);
                        setServiceKeyIDs(serviceIDs);

                        // Map hours and price for each selected service
                        const hoursMap = {};
                        modalData.serviceKeyIDs.forEach((s) => {
                              hoursMap[s.serviceKeyID] = {
                                    hours:
                                          s.budgetedHours !== null ? s.budgetedHours.toFixed(2) : "0.00",
                                    price: s.servicePrice !== null ? s.servicePrice.toFixed(2) : "0.00",
                                    canDelete: s.canDelete,
                              };
                        });

                        setServiceHours(hoursMap);

                        // Set project ID for update
                        setStatusObj({
                              ...stageObj,
                              clientProjectID: modalData.project.clientProjectID,
                        });
                  }
            } catch (error) {
                  console.error("Error fetching project modal data:", error);
            } finally {
                  setLoader(false);
            }
      };

      const GetProjectLookupListData = async (id) => {

            try {
                  const data = await GetProjectLookupList(id);

                  if (data?.statusCode === 200 && data?.responseData?.data) {
                        const List = data.responseData.data.map((item) => ({
                              value: item.projectID,
                              label: item.projectName,
                        }));
                        setProjectLookupList(List);
                  }
            } catch (error) {
                  console.log(error);
            }
      };


      const GetTeamLeadLookupListData = async () => {
            try {
                  // let response = await GetCountryLookupList();
                  let response = await GetTeamLeadLookupList(6);
                  // Check if response contains data
                  if (response?.statusCode === 200) {
                        const zoneDivisionalOptions = response?.responseData?.data.map((item) => ({
                              value: item.userID,
                              label: item.name,
                        }));
                        // Confirm correct mapping

                        setTeamLeadLookupList(zoneDivisionalOptions);
                  } else {
                        console.warn("Unexpected API response structure", response);
                  }
            } catch (error) {
                  console.error("Error fetching zone divisional lookup list:", error);
            }
      }


      const GetProjectManagerLookupListData = async () => {
            try {
                  // let response = await GetCountryLookupList();
                  let response = await GetProjectManagerLookupList(7);


                  // Check if response contains data
                  if (response?.statusCode === 200) {
                        const zoneDivisionalOptions = response?.responseData?.data.map((item) => ({
                              value: item.userID,
                              label: item.name,
                        }));
                        // Confirm correct mapping

                        setProjectManagerLookupList(zoneDivisionalOptions);
                  } else {
                        console.warn("Unexpected API response structure", response);
                  }
            } catch (error) {
                  console.error("Error fetching zone divisional lookup list:", error);
            }
      }


      const GetClientLookupListData = async () => {
            try {
                  // let response = await GetCountryLookupList();
                  let response = await GetClientLookupList();


                  // Check if response contains data
                  if (response?.statusCode === 200) {
                        const zoneDivisionalOptions = response?.responseData?.data.map((item) => ({
                              value: item.clientID,
                              label: item.clientName,
                        }));
                        // Confirm correct mapping

                        setClientLookupList(zoneDivisionalOptions);
                  } else {
                        console.warn("Unexpected API response structure", response);
                  }
            } catch (error) {
                  console.error("Error fetching zone divisional lookup list:", error);
            }
      }


      const GetJobCategoryLookupListData = async () => {
            try {
                  // let response = await GetCountryLookupList();
                  let response = await GetJobCategoryLookupList();


                  // Check if response contains data
                  if (response?.statusCode === 200) {
                        const zoneDivisionalOptions = response?.responseData?.data.map((item) => ({
                              value: item.jobCategoryID,
                              label: item.jobCategoryName,
                        }));
                        // Confirm correct mapping

                        setJobCategoryLookupList(zoneDivisionalOptions);
                  } else {
                        console.warn("Unexpected API response structure", response);
                  }
            } catch (error) {
                  console.error("Error fetching zone divisional lookup list:", error);
            }
      }

      const GetStatusLookupListData = async () => {
            try {
                  // let response = await GetCountryLookupList();
                  let response = await GetJobStatusLookupList();


                  // Check if response contains data
                  if (response?.statusCode === 200) {
                        const zoneDivisionalOptions = response?.responseData?.data.map((item) => ({
                              value: item.jobStatusID,
                              label: item.jobStatusName,
                        }));
                        // Confirm correct mapping

                        setStatusLookupList(zoneDivisionalOptions);
                  } else {
                        console.warn("Unexpected API response structure", response);
                  }
            } catch (error) {
                  console.error("Error fetching zone divisional lookup list:", error);
            }
      }
      // Handlers for project fields
      const handleProjectNameChange = (e) => {
            const value = e.target.value;
            if (/^[a-zA-Z0-9\s]*$/.test(value)) {
                  setProject((prev) => ({
                        ...prev,
                        projectName: value,
                  }));
            }
      };

      const handlePriceChange = (e) => {
            let value = e.target.value.replace(/\D/g, "");
            value = value.slice(0, 7);
            setProject({ ...project, price: value });
      };

      const handleTimelineChange = (e) => {
            let value = e.target.value.replace(/\D/g, "");
            value = value.slice(0, 5);
            setProject({ ...project, timeLineDays: value });
      };

      const handlePaymentTermsChange = (e) => {
            setProject({ ...project, paymentTerms: e.target.value });
      };

      const handleRemarkChange = (e) => {
            setProject({ ...project, remark: e.target.value });
      };

      const handleSubmit = async () => {

            const requiredFields = [
                  project.jobName,
                  project.projectID,
                  project.clientID,
                  project.categoryID,
                  project.assignedTL?.length,
                  project.asignedTeam?.length,
                  project.startDate,
                  project.endDate,
                  // project.jobStatusID,
                  // project.imageURL

            ];

            // If ANY field is missing or empty, show error
            const hasEmpty = requiredFields.some((field) => !field);

            if (hasEmpty) {
                  setRequireErrorMessage(true);
                  return;
            }
            setRequireErrorMessage(false); // optional: clear error
            //call api
            try {
                  const data = await AddUpdateJob({
                        ...project,
                        userKeyID: userKeyID
                  });

                  if (data?.statusCode === 200) {
                        setLoader(false);
                        setIsAddUpdateDone(true);
                        setShowSuccessPopupModal(true);
                  } else {
                        setLoader(false);
                        setIsErrorOpen(true);
                        const errorMessage = data?.response?.data?.errorMessage;
                        setErrorMessage(errorMessage);
                  }
            } catch (error) {
                  setLoader(false);
                  console.error("Error while adding/updating project:", error);
            }
      };


      const getFileNameFromUrl = (url) => {
            if (!url) return "";
            return url.substring(url.lastIndexOf('/') + 1);
      };

      const updateField = (field, value) => {
            setProject((prev) => ({ ...prev, [field]: value }));
      };
      const handleStartDateChange = (selectedDate) => {
            const fromDateUTC = new Date(Date.UTC(
                  selectedDate.getFullYear(),
                  selectedDate.getMonth(),
                  selectedDate.getDate()
            ));
            const fromDateISO = fromDateUTC.toISOString();
            updateField("startDate", fromDateISO);
            updateField("endDate", ""); // Reset toDate on new start date selection

      };

      // Handle End Date selection
      const handleEndDateChange = (selectedDate) => {
            const toDateUTC = new Date(Date.UTC(
                  selectedDate.getFullYear(),
                  selectedDate.getMonth(),
                  selectedDate.getDate()
            ));
            const toDate = toDateUTC.toISOString();
            const fromDate = new Date(project.startDate);

            setErrorMessage("");
            if (toDateUTC >= fromDate) {
                  updateField("endDate", toDate);
            } else {
                  setErrorMessage(
                        "End date must be greater than or equal to the start date."
                  );
                  updateField("endDate", "");
            }
      };


      return (
            <div className="fixed inset-0 flex items-center justify-center z-50 px-2 sm:px-4">
                  {/* Background Overlay */}
                  <div className="fixed inset-0 bg-black opacity-50"></div>

                  {/* Modal Box */}
                  <div className="bg-white rounded-lg shadow-lg z-10 w-full max-w-[95%] sm:max-w-[80%] md:max-w-[60%] lg:max-w-[50%] overflow-y-auto max-h-[85vh]">
                        <div className="bg-[#ECF6FF] px-4 py-3 rounded-t-lg border-b">
                              <h2 className="text-sm sm:text-base font-semibold text-gray-800">
                                    Add New Jobs
                              </h2>
                        </div>

                        <div className="p-6 sm:p-8 space-y-4">
                              {/* Job Name */}
                              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 text-12">


                                    {/* Client */}
                                    <div>
                                          <label className="block text-12 font-medium text-gray-700 mb-1">
                                                Client Name <span className="text-red-600">*</span>
                                          </label>
                                          <Select
                                                placeholder='Select Client'
                                                id="zoneID"
                                                options={clientLookupList}
                                                value={
                                                      clientLookupList.find(
                                                            (option) => option.value === project.clientID
                                                      ) || null
                                                }
                                                onChange={async (selectedOptions) => {
                                                      setProject((prev) => ({
                                                            ...prev,
                                                            clientID: selectedOptions.value
                                                      }))
                                                      if (selectedOptions) {
                                                            try {
                                                                  await GetProjectLookupListData(selectedOptions.value)
                                                            } catch (err) {
                                                                  console.log("error==>>", err)
                                                            }
                                                      }
                                                }
                                                }
                                                menuPosition="fixed"
                                                menuPlacement="auto"
                                                styles={{
                                                      ...customSelectStyles,
                                                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                }}

                                          />
                                          {requireErrorMessage && !project.clientID && (
                                                <label className="validation">{ERROR_MESSAGES}</label>
                                          )}
                                    </div>

                                    {/* Project */}
                                    <div>
                                          <label className="block text-12 font-medium text-gray-700 mb-1">
                                                Project   <span className="text-red-600">*</span>
                                          </label>
                                          <Select
                                                // className="w-full"
                                                options={projectLookupList}
                                                onChange={(value) => {

                                                      setProject({
                                                            ...project,
                                                            projectID: value.value
                                                      })
                                                }}
                                                // styles={globalSelectStyles}
                                                value={
                                                      projectLookupList.find(
                                                            (option) => option.value === project.projectID
                                                      ) || null
                                                }
                                                isDisabled={!project.clientID}
                                                menuPosition="fixed"
                                                menuPlacement="auto"
                                                styles={{
                                                      ...customSelectStyles,
                                                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                }}
                                          />
                                          {requireErrorMessage &&
                                                (project.projectID === "" ||
                                                      project.projectID === undefined ||
                                                      project.projectID === null) ? (
                                                <label className="validation">{ERROR_MESSAGES}</label>
                                          ) : (
                                                ""
                                          )}
                                    </div>

                                    {/* Job Name started  */}
                                    <div>
                                          <label className="block text-12 font-medium text-gray-700 mb-1">
                                                Job Name <span className="text-red-600">*</span>
                                          </label>
                                          <input
                                                type="text"
                                                maxLength={70}
                                                className="w-full border p-2 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
                                                placeholder="Job Name"
                                                value={project.jobName}
                                                onBlur={() => setProject(prev => ({
                                                      ...prev,
                                                      jobName: prev.jobName?.trim()
                                                }))}
                                                onChange={(e) => { setProject({ ...project, jobName: e.target.value.trimStart() }) }}
                                          />
                                          {requireErrorMessage && !project.jobName && (
                                                <label className="validation">{ERROR_MESSAGES}</label>
                                          )}
                                    </div>

                                    <div>
                                          <label className="block text-12 font-medium text-gray-700 mb-1">
                                                Category <span className="text-red-600">*</span>
                                          </label>
                                          <Select
                                                placeholder='Select  Category'
                                                id="jobCategoryId"
                                                options={jobCategoryLookupList}
                                                value={
                                                      jobCategoryLookupList.find(
                                                            (option) => option.value === project.categoryID
                                                      ) || null
                                                }
                                                onChange={(selectedOptions) =>
                                                      setProject((prev) => ({
                                                            ...prev,
                                                            categoryID: selectedOptions.value
                                                      }))
                                                }
                                                menuPosition="fixed"
                                                menuPlacement="auto"
                                                styles={{
                                                      ...customSelectStyles,
                                                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                }}

                                          />
                                          {requireErrorMessage && !project.categoryID && (
                                                <label className="validation">{ERROR_MESSAGES}</label>
                                          )}
                                    </div>


                                    <div>
                                          <label className="block text-12 font-medium text-gray-700 mb-1">
                                                Assigned TL<span className="text-red-600">*</span>
                                          </label>
                                          <Select
                                                placeholder='Assigned Team Lead'
                                                options={teamLeadLookupList}
                                                onChange={(selectedOptions) =>
                                                      setProject((prev) => ({
                                                            ...prev,
                                                            assignedTL: selectedOptions ? selectedOptions.map((opt) => opt.value) : []
                                                      }))
                                                }
                                                menuPosition="fixed"
                                                menuPlacement="auto"
                                                styles={{
                                                      ...customSelectStyles,
                                                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                }}
                                                value={teamLeadLookupList.filter((item) => project.assignedTL?.includes(item.value))}
                                                isMulti
                                          />
                                          {requireErrorMessage && !project.assignedTL?.length && (
                                                <label className="validation">{ERROR_MESSAGES}</label>
                                          )}
                                    </div>

                                    {/* Payment Terms */}
                                    <div>
                                          <label className="block text-12 font-medium text-gray-700 mb-1">
                                                Assigned Site Engineer<span className="text-red-600">*</span>
                                          </label>
                                          <Select
                                                placeholder='Assigned Site Engineer'
                                                options={projectMangerLookupList}
                                                onChange={(selectedOptions) =>
                                                      setProject((prev) => ({
                                                            ...prev,
                                                            asignedTeam: selectedOptions ? selectedOptions.map((opt) => opt.value) : []
                                                      }))
                                                }
                                                // styles={globalSelectStyles}
                                                value={projectMangerLookupList.filter((item) => project.asignedTeam?.includes(item.value))}
                                                isMulti
                                                menuPosition="fixed"
                                                menuPlacement="auto"
                                                styles={{
                                                      ...customSelectStyles,
                                                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                }}
                                          />
                                          {requireErrorMessage && !project.asignedTeam?.length && (
                                                <label className="validation">{ERROR_MESSAGES}</label>
                                          )}
                                    </div>
                                    <div>
                                          <label className="block text-12 font-medium text-gray-700 mb-1">
                                                Start Date<span className="text-red-600">*</span>
                                          </label>
                                          <DatePicker
                                                minDate={minDate}
                                                format="dd/MM/y"
                                                dayPlaceholder="dd"
                                                monthPlaceholder="mm"
                                                yearPlaceholder="yyyy"
                                                value={project.startDate}
                                                onChange={handleStartDateChange}
                                                className="p-1 border rounded-md text-12"
                                          />
                                          {/* <input
                                                type="date"
                                                maxLength={30}
                                                className="w-full border p-2 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
                                                placeholder="Start Date"
                                                value={project.startDate}
                                                onChange={(e) => { setProject({ ...project, startDate: e.target.value }) }}
                                          /> */}
                                          {requireErrorMessage && !project.startDate && (
                                                <label className="validation">{ERROR_MESSAGES}</label>
                                          )}

                                    </div>
                                    <div>
                                          <label className="block text-12 font-medium text-gray-700 mb-1">
                                                End Date<span className="text-red-600">*</span>
                                          </label>
                                          <DatePicker
                                                minDate={minDate}

                                                format="dd/MM/y"
                                                dayPlaceholder="dd"
                                                monthPlaceholder="mm"
                                                yearPlaceholder="yyyy"
                                                value={project.endDate}
                                                onChange={handleEndDateChange}
                                                className="p-1 border rounded-md text-12"
                                          />
                                          {/* <input
                                                type="date"
                                                maxLength={30}
                                                className="w-full border p-2 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
                                                placeholder="Start Date"
                                                value={project.endDate}
                                                onChange={(e) => { setProject({ ...project, endDate: e.target.value }) }}
                                          /> */}
                                          {requireErrorMessage && !project.endDate && (
                                                <label className="validation">{ERROR_MESSAGES}</label>
                                          )}
                                    </div>

                                    {/* <div>
                                          <label className="block text-12 font-medium text-gray-700 mb-1">
                                                Status  <span className="text-red-600">*</span>
                                          </label>
                                          <Select
                                                placeholder='Select Status'
                                                options={statusLookupList}
                                                onChange={(value) => setProject({
                                                      ...project,
                                                      jobStatusID: value.value
                                                })}
                                                // styles={globalSelectStyles}
                                                menuPlacement="auto"
                                                menuPosition="fixed"
                                                value={
                                                      statusLookupList.find(
                                                            (option) => option.value === project.jobStatusID
                                                      ) || null
                                                }
                                          />

                                          {requireErrorMessage && !project.jobStatusID && (
                                                <label className="validation">{ERROR_MESSAGES}</label>
                                          )}
                                    </div> */}


                                    {/* {
                                          project.jobStatusID == 4 &&
                                          (<div>
                                                <label className="block text-12 font-medium text-gray-700 mb-1">
                                                      Status Remark <span className="text-red-600">*</span>
                                                </label>
                                                <textarea
                                                      type="text"
                                                      maxLength={70}
                                                      className="w-full border p-2 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
                                                      placeholder="Enter status remark"
                                                      value={project.remark}
                                                      onBlur={() => setProject(prev => ({
                                                            ...prev,
                                                            remark: prev.remark?.trim()
                                                      }))}
                                                      onChange={(e) => { setProject({ ...project, remark: e.target.value.trimStart() }) }}
                                                />
                                                {requireErrorMessage && !project.remark && (
                                                      <label className="validation">{ERROR_MESSAGES}</label>
                                                )}
                                          </div>)} */}

                                    <div>
                                          <label className="block text-12 font-medium text-gray-700 mb-1">
                                                Upload Document
                                          </label>

                                          {/* Flex row: button + filename */}
                                          <div className="flex items-center gap-3 w-full">

                                                {/* Hidden file input */}
                                                <input
                                                      id="imageURL"
                                                      type="file"
                                                      accept="
                                                            .pdf,
                                                            .xls,
                                                            .xlsx,
                                                            .doc,
                                                            .docx,
                                                            application/pdf,
                                                            application/vnd.ms-excel,
                                                            application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                                                            application/msword,
                                                            application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                                      className="hidden"
                                                      onChange={async (e) => {
                                                            let file = e.target.files[0];
                                                            if (!file) return;

                                                            const ext = file.name.split('.').pop().toLowerCase();
                                                            const allowedExt = ["pdf", "xls", "xlsx", "doc", "docx"];


                                                            if (!allowedExt.includes(ext)) {
                                                                  setProject({
                                                                        ...project,
                                                                        imageURL: "",
                                                                        errors: { ...project.errors, uploadMedia: "Only PDF, Word and Excel files are allowed." }
                                                                  });
                                                                  return;
                                                            }



                                                            try {
                                                                  setLoader(true);
                                                                  const response = await UploadImageWithNodeApi({
                                                                        imageFile: file,
                                                                        userId: userKeyID,
                                                                        moduleName: "Job",
                                                                        projectName: "Technoland",
                                                                  });

                                                                  if (response.success) {
                                                                        setProject({
                                                                              ...project,
                                                                              imageURL: response.s3Url,
                                                                              errors: { ...project.errors, uploadMedia: "" }
                                                                        });
                                                                  }
                                                            } catch (error) {
                                                                  console.log("error", error);
                                                            } finally {
                                                                  setLoader(false);
                                                            }
                                                      }}
                                                />

                                                {/* Upload Button */}
                                                <label
                                                      htmlFor="imageURL"
                                                      className="cursor-pointer whitespace-nowrap bg-blue-500 text-white font-medium px-3 py-2 rounded-md shadow-sm hover:bg-primary/90 active:scale-95 transition-all"
                                                >
                                                      Upload File
                                                </label>

                                                {/* File name on right side (trim with ellipsis) */}
                                                {project.imageURL && (
                                                      <a
                                                            href={project?.imageURL}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            title="View File"
                                                            className="flex items-center gap-2 text-blue-600 hover:text-blue-800"
                                                      >
                                                            <span>View file</span>
                                                            <FaEye className="text-xl cursor-pointer" />
                                                      </a>
                                                )}

                                          </div>
                                          <p style={{ color: "#777", fontSize: "12px" }}>
                                                Upload only Excel, Word or PDF
                                          </p>
                                          {project?.errors?.uploadMedia && (
                                                <p className="text-red-500 text-11 mt-1">
                                                      {project?.errors?.uploadMedia}
                                                </p>
                                          )}

                                          {/* Error Message */}
                                          {/* {requireErrorMessage && !project.imageURL && (
                                                <label className="validation">{ERROR_MESSAGES}</label>
                                          )}                                      */}
                                    </div>
                              </div>
                        </div>
                        {errorMessage && (
                              <div className="text-center">
                                    <label className="validation ">{errorMessage}</label>
                              </div>
                        )}

                        {/* Footer Buttons */}
                        <div className="bg-gray-50 px-6 py-4 rounded-b-lg border-t flex justify-end gap-3">
                              <button
                                    type="button"
                                    className="px-4 py-2 bg-gray-300 rounded-md text-sm"
                                    onClick={onClose}
                              >
                                    Cancel
                              </button>
                              <button
                                    type="button"
                                    onClick={handleSubmit}
                                    className="bg-gradient-to-r from-[#0E4C84] to-[#00A7C1] hover:from-[#135EA0] hover:to-[#00B8D4] text-white px-5 py-2 rounded-lg text-12 font-medium shadow-md shadow-cyan-500/30 hover:shadow-cyan-400/40 transition-all duration-300"
                              >
                                    Submit
                              </button>
                        </div>

                        {/* Success Modal */}
                        <SuccessModal
                              isOpen={showSuccessPopupModal}
                              onClose={() => {
                                    onClose();
                                    // setShowSuccessPopupModal(false);
                              }}
                              modelAction={modelAction}
                              actionMessage={"Job"}
                        />
                  </div>
            </div>
      );
};

export default JobsAddUpdateModal;
